import React from 'react';
import {ColumnDescription} from "react-bootstrap-table-next";
import {useSelector} from "react-redux";
import paginationFactory from "react-bootstrap-table2-paginator";
import Contact from "../../../Models/Contact";
import {RootState} from "../../../Store/Reducers";
import LoadingComponent from "../LoadingComponent";
import Bootstrap4Table from "../Bootstrap4Table/Bootstrap4Table";
import ColumnAction from "../ColumnAction";

interface IProps {
  selectable?: boolean;
  setContactSelected?: (contact: Contact) => void;
  onOpenContactModal?: (e: any, row: Contact) => void;
  onOpenConfirmModal?: (row: Contact) => void;
  onClose?: (row: Contact) => void;
  perPage?: number;
}

const ContactTableComponent = ({
  selectable,
  setContactSelected,
  onOpenContactModal,
  onOpenConfirmModal,
  onClose,
  perPage = 15,
}: IProps) => {

  const {ContactReducer : {contacts}, LoadingReducer :{loadingContacts}} = useSelector((state: RootState) => state);

  const actionFormat = (cell: any, row: Contact) => {
    return(
      <ColumnAction
        onEdit={(e: any) => onOpenContactModal && onOpenContactModal(e, row)}
        onRemove={(e: any) => onOpenConfirmModal && onOpenConfirmModal(row)}
      />
    )
  }

  const columns: ColumnDescription[] = [
    {
      dataField: "name",
      text: "NOMBRES",
    },
    {
      dataField: "last_name",
      text: "APELLIDOS",
    },
    {
      dataField: "phone",
      text: "TELÉFONO",
    },
    {
      dataField: "email",
      text: "CORREO ELECTRÓNICO",
    },
    {
      dataField: "cellphone",
      text: "CELULAR",
    },
  ];

  let props: any = {};

  if (selectable) {
    props.selectRow = {
      mode: "radio",
      clickToSelect: true,
      onSelect: (contact: Contact) => {
        setContactSelected && setContactSelected(contact);
      }
    }
    props.rowEvents = {
      onClick: (e: any, row: Contact) => {
        setContactSelected && setContactSelected(row)
      },
      onDoubleClick: (e: any, row: Contact) => {
        onClose && onClose(row);
      }
    }
  } else {
    columns.push({
      dataField: "",
      text: "ACCIONES",
      formatter: actionFormat
    })
  }

  return (
    <>
      <LoadingComponent loading={loadingContacts.status} />
      <div className="table-responsive">
        <Bootstrap4Table
          data={contacts}
          columns={columns}
          loading={loadingContacts.status.isLoading()}
          pagination={paginationFactory({sizePerPage: perPage, hideSizePerPage: true})}
          {...props}
        />
      </div>
    </>
  );
};
export default ContactTableComponent;
